import { useMotionValue } from 'framer-motion';
import { Children, useEffect, useRef, useState, useCallback, useMemo } from 'react';

export const useDragSlider = (
  childRef: React.RefObject<HTMLDivElement>,
  children: React.ReactNode
) => {
  const ref = useRef<HTMLDivElement>(null);
  const x = useMotionValue(0);

  const [visibleSliderWidth, setVisibleSliderWidth] = useState(0);
  const [singleSlideWidth, setSingleSlideWidth] = useState(0);
  const [trueSliderWidth, setTrueSliderWidthh] = useState(0);
  const [sliderConstraints, setSliderConstraints] = useState(0);

  // get current widths 
  const calcSliderWidth = useCallback(() => {
    if (ref?.current?.clientWidth) {
      setVisibleSliderWidth(ref?.current?.clientWidth);
    }
    if (ref?.current?.scrollWidth) {
      setTrueSliderWidthh(ref?.current?.scrollWidth);
    }
    if (childRef?.current?.offsetWidth) {
      setSingleSlideWidth(childRef?.current?.offsetWidth);
    }
  }, [ref, childRef]);

  // constraints is calculated by
  // the full width needed to fit all children in overlay:hidden
  // minus width of visible slider
  const calcSliderConstraints = useCallback(() => {
    setSliderConstraints(trueSliderWidth - visibleSliderWidth);
  }, [trueSliderWidth, visibleSliderWidth]);


  // set for the 1st time widths, and cleanup in the end
  useEffect(() => {
    window.addEventListener('resize', calcSliderWidth);
    window.addEventListener('resize', calcSliderConstraints);
    return () => {
      window.removeEventListener('resize', calcSliderWidth);
      window.removeEventListener('resize', calcSliderConstraints);
    };
  }, []);

  // set new width if any window or element changes size
  useEffect(() => {
    calcSliderWidth();
    window.addEventListener('resize', calcSliderWidth);

    calcSliderConstraints();
    window.addEventListener('resize', calcSliderConstraints);
  }, [ref, trueSliderWidth, visibleSliderWidth, childRef]);

  const childrenCount = useMemo(() => {
    return Children.count(children) - 1
  }, [children])

  return {
    ref,
    x,
    sliderConstraints,
    visibleSliderWidth,
    singleSlideWidth,
    trueSliderWidth,
    childrenCount,
  };
};
